// extracted by mini-css-extract-plugin
export default {"buttons_container":"_5-SimpleResults_buttons_container__Sze17"};